<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import SpeechToTextOpus from './exercise/SpeechToTextOpus2.svelte'
  import UploadResult2 from './exercise/UploadResult2.svelte'
  import ResultDisplay2 from './exercise/ResultDisplay2.svelte'
  import ResultDisplayQuestionWithAnswer from './exercise/ResultDisplayQuestionWithAnswer.svelte'
  import * as animateScroll from 'svelte-scrollto'

  export let textToDisplay
  export let loginDetail
  export let exerciseDetail

  let showResultsPage = false
  let errorMsg
  let retryCounter = 0

  const dispatch = createEventDispatcher()

  onMount(async () => {
    initializeVoice()
  })

  //#region tts
  let textToRead = textToDisplay
  let subscriptionKey
  let serviceRegion = 'eastasia'
  let authorizationToken = ''
  let SpeechSDK
  let synthesizer
  let player
  let audioConfig
  let ttsToken
  let ttsButtonState = 'starting'
  let speechCounter = 0
  let language = 'en-US'
  let slowFlag = false
  const languageMapping = {
    'en-US': {
      alternatives: ['en-us'],
      voiceNames: ['en-US-GuyNeural', 'en-US-JennyNeural'],
    },
    'en-GB': {
      alternatives: ['en-gb', 'en-uk', 'en-UK'],
      voiceNames: ['en-GB-LibbyNeural', 'en-GB-RyanNeural'],
    },
    'en-IN': {
      alternatives: ['en-in'],
      voiceNames: ['en-IN-NeerjaNeural', 'en-IN-PrabhatNeural'],
    },
    'en-NG': {
      alternatives: ['en-ng'],
      voiceNames: ['en-NG-AbeoNeural', 'en-NG-EzinneNeural'],
    },
    'en-AU': {
      alternatives: ['en-au'],
      voiceNames: ['en-AU-AnnetteNeural', 'en-AU-DarrenNeural'],
    },
    'zh-TW': {
      alternatives: ['zh-tw'],
      voiceNames: ['zh-TW-HsiaoChenNeural', 'zh-TW-YunJheNeural'],
    },
    'cs-CZ': {
      alternatives: ['cs-cz'],
      voiceNames: ['cs-CZ-VlastaNeural', 'cs-CZ-AntoninNeural'],
    },
    'jp-JP': {
      alternatives: ['jp-JP'],
      voiceNames: ['ja-JP-NanamiNeural', 'ja-JP-KeitaNeural'],
    },
    'zh-CN': {
      alternatives: ['zh-cn'],
      voiceNames: ['zh-CN-XiaoxiaoNeural', 'zh-CN-YunyangNeural'],
    },
    'de-DE': {
      alternatives: ['de-DE'],
      voiceNames: ['de-DE-KatjaNeural', 'de-DE-ConradNeural'],
    },
  }

  function initializeVoice() {
    if (!!window.SpeechSDK) {
      SpeechSDK = window.SpeechSDK
      ttsButtonState = 'starting'

      initPlayPage()
    } else {
      ttsButtonState = 'error'
      console.log('error with SpeechSDK')
    }
  }

  function initPlayPage() {
    let data = {
      'Ocp-Apim-Subscription-Key': '07314c54f87947ecbb1b93c067a7c463',
    }
    postToken(
      'https://eastasia.api.cognitive.microsoft.com/sts/v1.0/issuetoken',
      data
    )
      .then((data) => {
        console.log('token', data)
        ttsToken = data
        ttsButtonState = 'ready'
      })
      .catch((error) => {
        console.error('token', error)
        ttsButtonState = 'error'
      })
  }

  async function postToken(url = '', data = {}) {
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        //'Content-Type': 'application/json'
        'Content-Type': 'application/x-www-form-urlencoded',
        ...data,
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })
    console.log('postToken - status', response.status)
    //uploadStatus.innerHTML = response.status;
    return response.text() // parses JSON response into native JavaScript objects
  }

  function playTextToSpeech() {
    if (ttsToken != null) {
      authorizationToken = ttsToken
    } else {
      console.log('missing token')
      return
    }
    let voiceName

    // if we got an authorization token, use the token. Otherwise use the provided subscription key
    let speechConfig
    if (authorizationToken) {
      speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
        authorizationToken,
        serviceRegion
      )
    } else {
      if (
        subscriptionKey.value === '' ||
        subscriptionKey.value === 'subscription'
      ) {
        alert(
          'Please enter your Microsoft Cognitive Services Speech subscription key!'
        )
        ttsButtonState = 'error'
        return
      }
      speechConfig = SpeechSDK.SpeechConfig.fromSubscription(
        subscriptionKey.value,
        serviceRegion
      )
    }
    console.log('language', language)

    if (!languageMapping[language]) {
      for (const [key, value] of Object.entries(languageMapping)) {
        const found = value.alternatives.find((el) => el == language)
        if (found) {
          language = key
          console.log(found)
        }
      }
    }
    speechConfig.speechSynthesisLanguage = language

    if (languageMapping[language]) {
      let numberOfVoice = languageMapping[language].voiceNames.length
      let selectedVoice =
        languageMapping[language].voiceNames[speechCounter % 2]
      // console.log("numberOfVoice", numberOfVoice);
      // console.log("selectedVoice", selectedVoice);
      speechConfig.speechSynthesisVoiceName = selectedVoice
      voiceName = selectedVoice
    } else {
      console.log('Error no language is available')
    }

    speechCounter++

    player = new SpeechSDK.SpeakerAudioDestination()
    audioConfig = SpeechSDK.AudioConfig.fromSpeakerOutput(player)
    synthesizer = new SpeechSDK.SpeechSynthesizer(speechConfig, audioConfig)

    ttsButtonState = 'playing'

    let ssml =
      `<speak xmlns="http://www.w3.org/2001/10/synthesis"
      xmlns:mstts="http://www.w3.org/2001/mstts"
      xmlns:emo="http://www.w3.org/2009/10/emotionml"
      version="1.0"
      xml:lang="` +
      language +
      `">
    <voice name="` +
      voiceName +
      `">
    <prosody rate="` +
      (slowFlag ? '-40%' : '-20%') +
      `"
            pitch="0%">` +
      textToRead +
      `</prosody>
    </voice>
    </speak>`

    synthesizer.speakSsmlAsync(
      ssml,
      function (result) {
        // console.log(result);
        if (
          result.reason === SpeechSDK.ResultReason.SynthesizingAudioCompleted
        ) {
          console.log('synthesis finished for [' + textToRead + ']')
        } else if (result.reason === SpeechSDK.ResultReason.Canceled) {
          console.log('synthesis failed. Error detail: ' + result.errorDetails)
          ttsButtonState = 'error'
        }
        synthesizer.close()
        synthesizer = undefined
      },
      function (err) {
        ttsButtonState = 'error'
        console.log('Synthesizer Error', err)

        synthesizer.close()
        synthesizer = undefined
      }
    )

    player.onAudioEnd = function (s) {
      console.log('onAudioEnd', s)
      ttsButtonState = 'ready'
    }
  }

  export function stopTextToSpeech() {
    console.log(player)
    if (player != null) {
      player.pause()
      ttsButtonState = 'ready'
    }
  }

  let fullText = true
  function clickPlayTTS(slow) {
    slowFlag = slow
    fullText = true
    textToRead = textToDisplay

    console.log('clickPlayTTS', ttsButtonState)
    mixpanel.track('Student Practice Record Play Button Clicked', {
      Slow: slowFlag,
    })

    if (ttsButtonState === 'ready') {
      playTextToSpeech()
      ttsButtonState = 'playing'
    } else if (ttsButtonState === 'playing') {
      stopTextToSpeech()
      playTextToSpeech()
    }
  }
  //#endregion

  // recording
  let recordingButtonState
  let recordings = []
  let submitSuccess = false
  let resultData = undefined

  function handleOpenLesson(event) {
    console.log('handleOpenLesson', event)
    dispatch('openLesson', event?.detail)
  }

  function handleNextExercise(event) {
    console.log('handleNextExercise', event)
    dispatch('nextExercise', event?.detail)
  }

  function tryAgain() {
    recordings = []
    retryCounter++

    submitSuccess = false
    resultData = undefined

    recordingButtonState = undefined
    errorMsg = undefined

    showResultsPage = false
  }

  function handleNewRecording(event) {
    recordings = [...recordings, event.detail]
  }

  function handleResultSubmit(event) {
    submitSuccess = true
    resultData = event.detail?.processResultData

    animateScroll.scrollToBottom()

    try {
      mixpanel.track('handleResultSubmit', event)
    } catch (error) {
      console.log('error mixpanel')
    }
  }
</script>

{#if showResultsPage === false}
  <div>
    <div class="container">
      <div class="row2">
        <div class="col2">
          <div class="instructions">Press record and answer the question!</div>
        </div>
      </div>

      <div class="row2" style="margin-top: 1vh;">
        <div class="col2">
          <div class="jumbotron exercise-container">
            <div class="question-container">
              <div class="teacher-role-text">Teacher</div>
              <div class="exerciseText">
                {textToDisplay}
              </div>
            </div>

            <div class="answer-container">
              <div class="student-role-text">You</div>
              <div class="answerText">"..... .... .... ......"</div>
            </div>

            <div class="row2 playback-row">
              <div class="col2" style="padding: 0px;">
                {#if ttsButtonState === 'starting'}
                  TTS initializing...
                {:else if ttsButtonState === 'playing' && fullText}
                  {#if slowFlag}
                    <button
                      id="play"
                      type="button"
                      class="play-icon play-asset"
                      on:click={() => clickPlayTTS(false)}
                    />
                    <button
                      id="playSlow"
                      type="button"
                      class="playSlow-icon playSlow-asset playSlow-asset-active"
                      on:click={() => stopTextToSpeech()}
                    />
                  {:else}
                    <button
                      id="play"
                      type="button"
                      class="play-icon play-asset play-asset-active"
                      on:click={() => stopTextToSpeech()}
                    />
                    <button
                      id="playSlow"
                      type="button"
                      class="playSlow-icon playSlow-asset"
                      on:click={() => clickPlayTTS(true)}
                    />
                  {/if}
                {:else if ttsButtonState === 'ready' || (ttsButtonState === 'playing' && !fullText)}
                  <button
                    id="play"
                    type="button"
                    class="play-icon play-asset"
                    on:click={() => clickPlayTTS(false)}
                  />
                  <button
                    id="playSlow"
                    type="button"
                    class="playSlow-icon playSlow-asset"
                    on:click={() => clickPlayTTS(true)}
                  />
                {:else if ttsButtonState === 'error'}
                  TTS Error!
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col2 offset-md-0 text-center"
        style="padding-top: 8px; padding-bottom: 8px; margin-top: 3vh"
      >
        {#if !submitSuccess}
          <SpeechToTextOpus
            on:message={handleNewRecording}
            bind:recordingButtonState
            timeLimit={exerciseDetail?.organizationCurrentSubscriptionLevel ===
            'SURREAL_TEACHER'
              ? 15
              : 30}
          />
          <!-- {:else}
      <i class="fas fa-microphone-alt-slash" /> -->
        {/if}
        {#if recordingButtonState === 'stop'}
          <UploadResult2
            on:message={handleResultSubmit}
            on:openLesson={handleOpenLesson}
            on:tryAgainExercise={tryAgain}
            on:nextExercise={handleNextExercise}
            on:openExercise={handleNextExercise}
            {loginDetail}
            {exerciseDetail}
            lastRecording={recordings.slice(-1)[0]}
          />
        {/if}
      </div>

      <!-- <div class="row2 footer-notes">
        <div class="col2">
          Please try not to pause for longer than 2 seconds when speaking. The
          text output may not be accurate if you pause. If your recording was
          cut off, please try again with no pauses.
        </div>
      </div> -->
    </div>
  </div>
  {#key retryCounter}
    {#if exerciseDetail.type === 'QUESTION'}
      <ResultDisplay2
        on:tryAgainExercise={tryAgain}
        on:openLesson={handleOpenLesson}
        on:nextExercise={handleNextExercise}
        {resultData}
        lastRecording={recordings.slice(-1)[0]}
        language={exerciseDetail.courseLanguage}
        courseScoringType={exerciseDetail.courseScoringType}
        exerciseType={exerciseDetail.type}
        {exerciseDetail}
      />
    {:else if exerciseDetail.type === 'QUESTION_FIX_ANSWER'}
      <ResultDisplayQuestionWithAnswer
        on:tryAgainExercise={tryAgain}
        on:openLesson={handleOpenLesson}
        on:nextExercise={handleNextExercise}
        {resultData}
        lastRecording={recordings.slice(-1)[0]}
        language={exerciseDetail.courseLanguage}
        courseScoringType={exerciseDetail.courseScoringType}
        exerciseType={exerciseDetail.type}
        {exerciseDetail}
      />
    {/if}
  {/key}
{/if}

<style>
  .instructions {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 1.125em;

    color: #5e5e61;
  }

  /* Play 1x speed button */
  #play {
    border: none;
    cursor: pointer;
    background-color: transparent;
    width: 26px;
    height: 26px;
    overflow: hidden;
    display: inline-block;
  }

  .play-asset {
    background-image: url("data:image/svg+xml, %3Csvg width='24' height='24' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.66667 17.25L16.6667 12L9.66667 6.74998V17.25ZM12 0.333313C5.56 0.333313 0.333336 5.55998 0.333336 12C0.333336 18.44 5.56 23.6666 12 23.6666C18.44 23.6666 23.6667 18.44 23.6667 12C23.6667 5.55998 18.44 0.333313 12 0.333313ZM12 21.3333C6.855 21.3333 2.66667 17.145 2.66667 12C2.66667 6.85498 6.855 2.66665 12 2.66665C17.145 2.66665 21.3333 6.85498 21.3333 12C21.3333 17.145 17.145 21.3333 12 21.3333Z' fill='%235E5E61'/%3E%3C/svg%3E%0A");
    background-size: cover;
  }

  .play-asset:hover,
  .play-asset:focus,
  .play-asset-active {
    background-image: url("data:image/svg+xml, %3Csvg width='23' height='23' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='22' height='22' rx='11' fill='%2300A094' stroke='%23028A80'/%3E%3Cpath d='M9 6V17L16 11.5L9 6Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  /* Play 0.5x speed button */
  #playSlow {
    border: none;
    cursor: pointer;
    background-color: transparent;
  }

  .playSlow-icon {
    display: inline-block;
    width: 53px;
    height: 26px;
  }

  .playSlow-asset {
    background-image: url("data:image/svg+xml, %3Csvg width='53' height='26' viewBox='0 0 53 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.072 17.144C24.272 17.144 23.64 16.804 23.176 16.124C22.712 15.436 22.48 14.444 22.48 13.148C22.48 11.852 22.712 10.876 23.176 10.22C23.64 9.556 24.272 9.224 25.072 9.224C25.872 9.224 26.504 9.556 26.968 10.22C27.432 10.884 27.664 11.86 27.664 13.148C27.664 14.444 27.432 15.436 26.968 16.124C26.504 16.804 25.872 17.144 25.072 17.144ZM25.072 16.064C25.256 16.064 25.424 16.016 25.576 15.92C25.736 15.816 25.872 15.648 25.984 15.416C26.096 15.184 26.184 14.884 26.248 14.516C26.312 14.148 26.344 13.692 26.344 13.148C26.344 12.612 26.312 12.164 26.248 11.804C26.184 11.436 26.096 11.14 25.984 10.916C25.872 10.692 25.736 10.536 25.576 10.448C25.424 10.352 25.256 10.304 25.072 10.304C24.888 10.304 24.716 10.352 24.556 10.448C24.404 10.536 24.272 10.692 24.16 10.916C24.048 11.14 23.96 11.436 23.896 11.804C23.832 12.164 23.8 12.612 23.8 13.148C23.8 13.692 23.832 14.148 23.896 14.516C23.96 14.884 24.048 15.184 24.16 15.416C24.272 15.648 24.404 15.816 24.556 15.92C24.716 16.016 24.888 16.064 25.072 16.064ZM29.8083 17.144C29.5523 17.144 29.3363 17.056 29.1603 16.88C28.9923 16.704 28.9083 16.48 28.9083 16.208C28.9083 15.936 28.9923 15.712 29.1603 15.536C29.3363 15.36 29.5523 15.272 29.8083 15.272C30.0643 15.272 30.2763 15.36 30.4443 15.536C30.6123 15.712 30.6963 15.936 30.6963 16.208C30.6963 16.48 30.6123 16.704 30.4443 16.88C30.2763 17.056 30.0643 17.144 29.8083 17.144ZM34.349 17.144C33.733 17.144 33.213 17.04 32.789 16.832C32.373 16.616 32.025 16.368 31.745 16.088L32.381 15.2C32.613 15.416 32.873 15.608 33.161 15.776C33.449 15.936 33.785 16.016 34.169 16.016C34.601 16.016 34.953 15.888 35.225 15.632C35.505 15.376 35.645 15.016 35.645 14.552C35.645 14.096 35.517 13.744 35.261 13.496C35.005 13.248 34.665 13.124 34.241 13.124C33.993 13.124 33.785 13.16 33.617 13.232C33.449 13.296 33.249 13.404 33.017 13.556L32.357 13.136L32.585 9.368H36.665V10.532H33.785L33.629 12.38C33.789 12.3 33.945 12.24 34.097 12.2C34.257 12.152 34.437 12.128 34.637 12.128C34.965 12.128 35.273 12.176 35.561 12.272C35.857 12.368 36.113 12.516 36.329 12.716C36.545 12.908 36.717 13.156 36.845 13.46C36.973 13.756 37.037 14.108 37.037 14.516C37.037 14.932 36.961 15.304 36.809 15.632C36.665 15.96 36.469 16.236 36.221 16.46C35.973 16.684 35.685 16.856 35.357 16.976C35.037 17.088 34.701 17.144 34.349 17.144ZM37.7774 17L39.6494 13.928L37.8974 11.108H39.3854L40.0454 12.224C40.1334 12.384 40.2214 12.552 40.3094 12.728C40.4054 12.896 40.4974 13.06 40.5854 13.22H40.6334C40.7054 13.06 40.7814 12.896 40.8614 12.728C40.9414 12.552 41.0174 12.384 41.0894 12.224L41.6534 11.108H43.0814L41.3414 14.084L43.2134 17H41.7254L41.0054 15.836C40.9094 15.66 40.8094 15.484 40.7054 15.308C40.6094 15.132 40.5094 14.96 40.4054 14.792H40.3574C40.2694 14.96 40.1814 15.132 40.0934 15.308C40.0134 15.476 39.9294 15.652 39.8414 15.836L39.2174 17H37.7774Z' fill='%235E5E61'/%3E%3Crect x='1' y='1' width='51' height='24' rx='12' stroke='%235E5E61' stroke-width='2'/%3E%3Cpath d='M12 8V19L19 13.5L12 8Z' fill='%235E5E61'/%3E%3C/svg%3E%0A");
    background-size: cover;
  }

  .playSlow-asset:hover,
  .playSlow-asset:focus,
  .playSlow-asset-active {
    background-image: url("data:image/svg+xml, %3Csvg width='53' height='26' viewBox='0 0 53 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='52' height='25' rx='12.5' fill='%2300A094' stroke='%23028A80'/%3E%3Cpath d='M25.072 17.144C24.272 17.144 23.64 16.804 23.176 16.124C22.712 15.436 22.48 14.444 22.48 13.148C22.48 11.852 22.712 10.876 23.176 10.22C23.64 9.556 24.272 9.224 25.072 9.224C25.872 9.224 26.504 9.556 26.968 10.22C27.432 10.884 27.664 11.86 27.664 13.148C27.664 14.444 27.432 15.436 26.968 16.124C26.504 16.804 25.872 17.144 25.072 17.144ZM25.072 16.064C25.256 16.064 25.424 16.016 25.576 15.92C25.736 15.816 25.872 15.648 25.984 15.416C26.096 15.184 26.184 14.884 26.248 14.516C26.312 14.148 26.344 13.692 26.344 13.148C26.344 12.612 26.312 12.164 26.248 11.804C26.184 11.436 26.096 11.14 25.984 10.916C25.872 10.692 25.736 10.536 25.576 10.448C25.424 10.352 25.256 10.304 25.072 10.304C24.888 10.304 24.716 10.352 24.556 10.448C24.404 10.536 24.272 10.692 24.16 10.916C24.048 11.14 23.96 11.436 23.896 11.804C23.832 12.164 23.8 12.612 23.8 13.148C23.8 13.692 23.832 14.148 23.896 14.516C23.96 14.884 24.048 15.184 24.16 15.416C24.272 15.648 24.404 15.816 24.556 15.92C24.716 16.016 24.888 16.064 25.072 16.064ZM29.8083 17.144C29.5523 17.144 29.3363 17.056 29.1603 16.88C28.9923 16.704 28.9083 16.48 28.9083 16.208C28.9083 15.936 28.9923 15.712 29.1603 15.536C29.3363 15.36 29.5523 15.272 29.8083 15.272C30.0643 15.272 30.2763 15.36 30.4443 15.536C30.6123 15.712 30.6963 15.936 30.6963 16.208C30.6963 16.48 30.6123 16.704 30.4443 16.88C30.2763 17.056 30.0643 17.144 29.8083 17.144ZM34.349 17.144C33.733 17.144 33.213 17.04 32.789 16.832C32.373 16.616 32.025 16.368 31.745 16.088L32.381 15.2C32.613 15.416 32.873 15.608 33.161 15.776C33.449 15.936 33.785 16.016 34.169 16.016C34.601 16.016 34.953 15.888 35.225 15.632C35.505 15.376 35.645 15.016 35.645 14.552C35.645 14.096 35.517 13.744 35.261 13.496C35.005 13.248 34.665 13.124 34.241 13.124C33.993 13.124 33.785 13.16 33.617 13.232C33.449 13.296 33.249 13.404 33.017 13.556L32.357 13.136L32.585 9.368H36.665V10.532H33.785L33.629 12.38C33.789 12.3 33.945 12.24 34.097 12.2C34.257 12.152 34.437 12.128 34.637 12.128C34.965 12.128 35.273 12.176 35.561 12.272C35.857 12.368 36.113 12.516 36.329 12.716C36.545 12.908 36.717 13.156 36.845 13.46C36.973 13.756 37.037 14.108 37.037 14.516C37.037 14.932 36.961 15.304 36.809 15.632C36.665 15.96 36.469 16.236 36.221 16.46C35.973 16.684 35.685 16.856 35.357 16.976C35.037 17.088 34.701 17.144 34.349 17.144ZM37.7774 17L39.6494 13.928L37.8974 11.108H39.3854L40.0454 12.224C40.1334 12.384 40.2214 12.552 40.3094 12.728C40.4054 12.896 40.4974 13.06 40.5854 13.22H40.6334C40.7054 13.06 40.7814 12.896 40.8614 12.728C40.9414 12.552 41.0174 12.384 41.0894 12.224L41.6534 11.108H43.0814L41.3414 14.084L43.2134 17H41.7254L41.0054 15.836C40.9094 15.66 40.8094 15.484 40.7054 15.308C40.6094 15.132 40.5094 14.96 40.4054 14.792H40.3574C40.2694 14.96 40.1814 15.132 40.0934 15.308C40.0134 15.476 39.9294 15.652 39.8414 15.836L39.2174 17H37.7774Z' fill='white'/%3E%3Cpath d='M12 8V19L19 13.5L12 8Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  /* Exercise Container */
  .exercise-container {
    overflow: auto;
    background-color: transparent;
    border: 1px solid #e5e5e5;
    border-radius: 5px;

    padding: 2vh;
    margin: 0px;
  }

  .question-container {
    margin-right: 20vw !important;
  }

  .teacher-role-text {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    color: #000000;
  }

  .exerciseText {
    padding: 2vh;
    width: fit-content;
    max-width: 60vw;
    font-family: 'Roboto Slab';
    font-style: normal;
    font-size: 1.13rem;
    color: #000000;

    background: #fff3e6;
    border-radius: 20px;

    word-wrap: break-word;
    white-space: pre-wrap;
  }

  .answer-container {
    margin-left: 50vw !important;
  }

  .student-role-text {
    text-align: right;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    color: #000000;
  }

  .answerText {
    float: right;
    width: max-content;
    padding: 2vh;

    font-family: 'Roboto Slab';
    font-style: normal;
    font-size: 1.13rem;
    color: #000000;

    background: #e5f5f4;
    border-radius: 20px;
  }

  .playback-row {
    clear: right;
  }

  .footer-notes {
    font-family: Roboto Slab;
    font-size: 0.8em;
    line-height: 125%;
    color: rgba(0, 0, 0, 0.5);
    opacity: 0.9;

    margin: 4vh 0 2vh 0;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-device-width: 600px) {
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
  }

  .row2 {
    display: flex;
    flex-wrap: wrap;
  }

  .col2 {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
</style>
